import { Currency, NumberField, SmallBodyText } from '../../../../../ui-toolkit';
import { useUpdateOrderFromSummaryItem } from '../hooks/useUpdateOrderFromSummaryItem';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import React from 'react';
import { eTransactionCategory } from '../../../../../ui-toolkit/enums/eTransactionType';

export const PropertyValue: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();
  const isPurchase = order.transaction.transaction_category === eTransactionCategory.Purchase;

  if (isPurchase) {
    return (
      <SummaryItemWithEdit
        label={`Purchase Price`}
        tab={`summary`}
        field={`purchase_price`}
        onUpdate={(_, value) => onPatchOrderInformation({ purchasePrice: value })}
        order={order}
        editControl={NumberField}
        editProps={{ placeholder: '$###,###.##', mode: 'currency' }}
      >
        {order.transaction.purchase_price ? (
          <Currency data-test-id={'purchase-price'} value={order.transaction.purchase_price} />
        ) : (
          <SmallBodyText intent={`faded`}>-</SmallBodyText>
        )}
      </SummaryItemWithEdit>
    );
  }
  return (
    <SummaryItemWithEdit
      label={`Estimated Property Value`}
      tab={`summary`}
      field={`estimated_property_value`}
      onUpdate={(_, value) => onPatchOrderInformation({ estimatedPropertyValue: value ?? null })}
      order={order}
      editControl={NumberField}
      editProps={{ placeholder: '$###,###.##', mode: 'currency' }}
    >
      {order.transaction.estimated_property_value ? (
        <Currency data-test-id={'estimated-property-value'} value={order.transaction.estimated_property_value} />
      ) : (
        <SmallBodyText intent={`faded`}>-</SmallBodyText>
      )}
    </SummaryItemWithEdit>
  );
};
